import PartialEarn from "../../Earn/PartialEarn";

export default function CryptoDetailsEarn({ coin }) {
  return <PartialEarn coin={coin} availableCoins={[coin]} />;
}
